module.exports = __webpack_public_path__ + "static/img/7.b1e9dd2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/eng/7.png
// module id = 4QKE
// module chunks = 0